import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { isNumber } from '@sparling/financial-common'

const Schema = yup.object().shape({
  asset: yup.string().required('Please select'),
  wallet: yup.string().required('Please select'),
  amount: yup
    .string()
    .required('Is a required field')
    // eslint-disable-next-line
    .test('isNumber', 'Must be a numeric value', (value: any): boolean => isNumber(value))
    // eslint-disable-next-line
    .test('isPositiveNumber', 'Must be a positive numeric value', (value: any): boolean =>
      /^\+?(\d+(\.(\d+)?)?|\.\d+)$/.test(value),
    )
    // eslint-disable-next-line
    .test('isNotZero', 'Must be a positive numeric value', (value: any): boolean => Number(value) > 0)
    .nullable(true),
})

export const resolver = yupResolver(Schema)
